import { render } from "./AnnouncementUnreadIcon.vue?vue&type=template&id=32428570"
import script from "./AnnouncementUnreadIcon.vue?vue&type=script&lang=js"
export * from "./AnnouncementUnreadIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__